import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Header } from "../components/landing/Header";
import { Hero } from "../components/landing/Hero";
import { Services } from "../components/landing/Services";
import { Industries } from "../components/landing/Industries";
import { HowItWorks } from "../components/landing/HowItWorks";
import { Calculator } from "../components/landing/Calculator";
import { LeadForms } from "../components/landing/LeadForms";
import { Trust } from "../components/landing/Trust";
import { FAQ } from "../components/landing/FAQ";
import { Footer } from "../components/landing/Footer";
import { RolesCatalog } from "../components/landing/RolesCatalog";
import { HomeServices } from "../components/landing/HomeServices";
import { ChoicePopup } from "../components/landing/ChoicePopup";
import { WhatsAppButton, buildWhatsAppMessage } from "../components/landing/WhatsAppButton";

export default function Landing() {
  const [tab, setTab] = useState("employer");
  const [prefill, setPrefill] = useState(null);
  const [waContext, setWaContext] = useState(null);
  const openForm = (t) => {
    setTab(t);
    document.getElementById("register")?.scrollIntoView({ behavior: "smooth" });
  };
  const pickRole = (t, department, job_role) => {
    setPrefill({ tab: t, department, job_role, at: Date.now() });
    openForm(t);
    toast.success(`Role selected: ${job_role}`, { description: t === "employer" ? "Fill in the rest of your requirement below." : "Fill in your details below." });
  };
  useEffect(() => {
    if (new URLSearchParams(window.location.search).get("join") === "housekeeping") {
      setTimeout(() => pickRole("worker", "book_service", "Cleaner"), 1200);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="landing-page grain min-h-screen bg-[#0B1120] font-body text-slate-100">
      <ChoicePopup onPick={openForm} />
      <Header openForm={openForm} />
      <main>
        <Hero openForm={openForm} />
        <Services />
        <HomeServices />
        <RolesCatalog onPick={pickRole} />
        <Industries />
        <HowItWorks />
        <Calculator />
        <LeadForms tab={tab} setTab={setTab} prefill={prefill} onContext={setWaContext} />
        <Trust />
        <FAQ />
      </main>
      <Footer openForm={openForm} />
      <WhatsAppButton message={buildWhatsAppMessage(waContext)} />
    </div>
  );
}
